import { render, staticRenderFns } from "./petrolreject.vue?vue&type=template&id=d281152a&"
import script from "./petrolreject.vue?vue&type=script&lang=js&"
export * from "./petrolreject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports